var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{domProps:{"innerHTML":_vm._s(_vm.codigo ? _vm.codigo : /*html*/ "<i class='fa-solid fa-circle-question'></i>")},on:{"click":_vm.copiarPresupuesto}})}
var staticRenderFns = []

export { render, staticRenderFns }